import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PaginationElementComponent from "@/components/PaginationElementComponent";
import { Link, useNavigate } from "react-router-dom";

const Companies = ({ props, descriptionHeading }) => {
  const {
    candidatesMatchedQuantityInt,
    industryPropertiesTitle,
    page,
    naicsCodes,
    companyInformationCompany,
    candidatesMatchedQuantity,
    pageSize,
    firstHit,
    lastHit,
    candidatesMatchedQuantityIsNullOrZeroString,
    countryMapValue
  } = props;
  const { t } = useTranslation();
  const [scrollToSearchResultsContainer, setScrollToSearchResultsContainer] =
    useState(false);
  const isMobileWidth = false;
  const [pageNumber, setPageNumber] = useState(page || 1);
  const navigate = useNavigate();
  const pageLimit = Number(t("companyInformation.pageLimit"));
  const [currentPageNumber, setCurrentPageNumber] = useState();

  useEffect(() => {
    const queryParams = new URLSearchParams({
      page: String(pageNumber),
    }).toString();
    if (currentPageNumber !== undefined) {
      navigate(`?${queryParams}`);
    }
    setCurrentPageNumber(pageNumber);
  }, [pageNumber]);

  const description = `${t("companyInformation.description.part1")}${
    descriptionHeading["title"]
  }${t(
    "companyInformation.description.part2"
  )} ${industryPropertiesTitle}${t(
    "companyInformation.description.part3"
  )}    ${candidatesMatchedQuantity} ${industryPropertiesTitle} ${t(
    "companyInformation.description.part4"
  )} `;


  const industrySubTitle = industryPropertiesTitle || null;
  const countryLand = countryMapValue || null;
  function isSafeUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.origin === window.location.href
    } catch (e) {
      return false;
    }
  }

  const rawurl = window.location.href;
  const redirectUrl =  isSafeUrl(rawurl) ? rawurl : '/';
  return (
    <>
      <div className="industryCrawlCompaniesVTwoWrapper">
       { candidatesMatchedQuantityIsNullOrZeroString ? 
       <>
       <h2 className="noMatchingCriteria">{t("companyInformation.noMatchingCriteria")}</h2> 
       <div className="candidatesMatchedQuantityIsNullOrZeroLinkWrapper">
          <a className=" candidatesMatchedQuantityIsNullOrZeroLinkWrapper text-decoration-none" href={redirectUrl}>
          View companies in the {industrySubTitle} industry in {countryLand}.
          </a>
        </div>
       </>
       :<div className="container">
          <div className="description">{description}</div>
          <div className="codes">
            <div>
              <div className="codes-title naics">
                {t("companyInformation.naicsCodes")}:{" "}
                <span>{naicsCodes?.[0]}</span>
              </div>
            </div>
          </div>
          {companyInformationCompany &&
            companyInformationCompany.length > 0 && (
              <div>
                <div className="results-summary">
                  {t("companyInformation.showingInPagination")} {firstHit}-
                  {lastHit} {t("companyInformation.ofInPagination")}{" "}
                  {candidatesMatchedQuantity}
                </div>

                <div id="companyResults">
                  <div className="row tableHeading">
                    <div className="col-md-6">
                      &nbsp; {t("companyInformation.company")}
                    </div>
                    <div className="col-md-4">
                      {t("companyInformation.location")}
                    </div>
                    <div className="col-md-2">
                      {" "}
                      {t("companyInformation.salesRevenue")}
                    </div>
                  </div>

                  {companyInformationCompany.map((data, index) => (
                    <>
                      <div className="row tableData" key={index}>
                        <div className="col-md-6">
                          <Link
                            to={`/business-directory/company-profiles.${data["companyNameUrl"]}`}
                            className="companyName"
                          >
                            {data["primaryName"]}
                          </Link>
                        </div>

                        <div className="col-md-4">
                          <div className="show-mobile">
                            {t("companyInformation.country")}
                          </div>
                          {data["addressLocalityNameFormatted"]?.replaceAll(
                            "&nbsp;",
                            " "
                          )}
                          ,{" "}
                          {data["addressRegionNameFormatted"]?.replaceAll(
                            "&nbsp;",
                            " "
                          )}
                          <br />
                          {data["addressCountryName"]?.replaceAll(
                            "&nbsp;",
                            " "
                          )}
                        </div>

                        <div className="col-md-2 last">
                          <div className="show-mobile">
                            {t("companyInformation.salesRevenue")}
                          </div>
                          {t("companyInformation.salesPrefix")}
                          {data["salesRevenue"]}
                          {t("companyInformation.salesSuffix")}
                        </div>
                      </div>
                    </>
                  ))}
                  <PaginationElementComponent
                    currentPage={pageNumber}
                    currentPageValueClassName="currentPageValue"
                    ellipsesClassName="ellipses"
                    ltgtClassName="ltgt"
                    nextButtonClassName="nextButton"
                    nextClassName="next"
                    onPageChange={(nu) => {
                      setPageNumber(nu);
                      setScrollToSearchResultsContainer(true);
                    }}
                    pageValueButtonClassName="pageValueButton"
                    paginationContainerRef={void 0}
                    previousButtonClassName="previousButton"
                    previousClassName="previous"
                    siblings={isMobileWidth ? 3 : 5}
                    totalPages={window.Math.min(
                      pageLimit,
                      window.Math.ceil(candidatesMatchedQuantityInt / pageSize)
                    )}
                    wrapperClassName="paginationWrapper"
                  />
                </div>
              </div>
            )}
        </div>}
      </div>
    </>
  );
};

export default Companies;

// setScrollToSearchResultsContainer(false);  in API data
